import styled from "styled-components";
import { WidgetStyle } from "../widgetStyle";

export const GenericWidgetStyle = styled(WidgetStyle)``;
